import {
   Unauthorized,
   SignUp,
   SignedOut,
   Authorize,
   SignIn,
   SignOut,
} from "@views/index"
import {
   authGuard,
   subscriptionGuard,
   subscriptionProjectGuard,
   orgGuard,
   putOnOnboardingStep,
} from "../guards/composable"
import Overview from "@views/Overview.vue"
import { SubscriptionError } from "@views/onboarding"

export default [
   {
      name: "Home",
      path: "",
      component: Overview,
      beforeEnter: subscriptionProjectGuard,
   },
   {
      path: "/sign-in",
      name: "SignIn",
      component: SignIn,
      beforeEnter: putOnOnboardingStep,
   },
   {
      path: "/sign-in/factor-one",
      name: "SignInFactorOne",
      component: SignIn,
   },
   {
      path: "/sign-in/factor-two",
      name: "SignInFactorOnTwo",
      component: SignIn,
   },
   {
      path: "/sign-in/reset-password",
      name: "SignInPWReset",
      component: SignIn,
   },
   {
      path: "/sign-in/reset-password-success",
      name: "SignInPWResetSuccess",
      component: SignIn,
   },
   {
      path: "/sign-in/sso-callback",
      name: "SignInSSO",
      component: SignIn,
   },
   {
      path: "/sign-in/verify",
      name: "SignInVerify",
      component: SignIn,
   },
   {
      path: "/sign-in/choose",
      name: "SignInChoose",
      component: SignIn,
   },
   {
      path: "/sign-out",
      name: "SignOut",
      component: SignOut,
      beforeEnter: authGuard,
   },
   {
      path: "/sign-up",
      name: "SignUp",
      component: SignUp,
      meta: {
         layout: "AppLayoutDefault",
      },
      beforeEnter: putOnOnboardingStep,
   },
   {
      path: "/sign-up/verify-email-address",
      name: "VerifyEmailAddress",
      component: SignUp,
      meta: {
         layout: "AppLayoutDefault",
      },
   },
   {
      path: "/signed-out",
      name: "SignedOut",
      component: SignedOut,
   },
   {
      path: "/unauthorized",
      name: "Unauthorized",
      component: Unauthorized,
      beforeEnter: authGuard,
   },
   {
      path: "/authorize",
      name: "Authorize",
      component: Authorize,
      beforeEnter: subscriptionGuard,
   },
   {
      path: "/checkout/confirmation",
      name: "SubscriptionConfirmation",
      component: () => import("@views/SubscriptionConfirmation.vue"),
      meta: {
         layout: "AppLayoutDefault",
      },
      beforeEnter: orgGuard,
   },
   {
      path: "/subscription-error",
      name: "SubscriptionError",
      component: SubscriptionError,
      meta: {
         layout: "SubscriptionErrorLayout",
      },
      beforeEnter: orgGuard,
   },
]
